$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	// スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	const swiper = new Swiper('.mv_swiper', {
		// slidesPerView: 1.3,
		slidesPerView: 'auto',
		centeredSlides: true,
		loop:true,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			320: {
				spaceBetween: 19,
			},
			// 768px以上の場合
			767: {
				spaceBetween: 50,
			},
		},
	});

	//導入事例スライド トップページ
	const case_swiper_top = new Swiper('.case_swiper_top', {
		loop:true,
		slidesPerView: 'auto',
		centeredSlides: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1.24,
				spaceBetween: 19,
			},
			// 768px以上の場合
			767: {
				slidesPerView: 'auto',
				spaceBetween: 30,
			},
		},
	});

});